@if(data) {
<div class="weather-container">
    <!-- Header / Current -->
    <div class="weather-header">
        <div class="current-info">
            <div class="weather-icon-large">{{ data.current.icon }}</div>
            <div class="city-details">
                <h4 class="city-name">{{ data.city }}</h4>
                <p class="status-tag">TIEMPO REAL</p>
            </div>
        </div>
        <div class="current-temp">{{ data.current.temp }}°C</div>
    </div>

    <!-- Forecast -->
    <div class="forecast-grid">
        @for(day of data.forecast; track $index) {
        <div class="forecast-day">
            <span class="day-label">{{ day.day }}</span>
            <span class="day-icon">{{ day.icon }}</span>
            <div class="temp-range">
                <span class="max-t">{{ day.max_temp }}°</span>
                <span class="min-t">{{ day.min_temp }}°</span>
            </div>
        </div>
        }
    </div>

    <div class="weather-footer">
        <span class="footer-text">
            <span class="sparkle">✨</span> Pronóstico vía Open-Meteo
        </span>
    </div>
</div>
}